<template>
  <div>
    <section class="container">
      <div class="wrapper">
        <h2 class="col5 section_title">
          <strong>ログインできません</strong>
        </h2>

        <div class="col7 wrap_pr_2col input_area">
          <p>
            このアカウントではこちらのページをご使用になれません。
          </p>
        </div>
        <!-- wrap_pr_2col input_area -->
      </div>
      <!-- wrapper -->
    </section>
    <!-- container -->
  </div>
</template>

<script>
export default {
  beforeRouteLeave(to, from, next) {
    if (to.name !== "Top") {
      next(false);
    }
    next();
  }
};
</script>
